import { render, staticRenderFns } from "./calificaciones_materialapoyo.vue?vue&type=template&id=d68ed42c"
import script from "./calificaciones_materialapoyo.vue?vue&type=script&lang=js"
export * from "./calificaciones_materialapoyo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports